export default {
  namespaced: true,
  breadcrumbs: {
    vaas: {
      camera_manager: {
        master_account: 'VaaS > Gerenciador de Câmeras > Conta Mestra',
        reseller: 'VaaS > Gerenciador de Câmeras > Revendedor',
        cameras: 'VaaS > Gerenciador de Câmeras > Câmeras',
        status_cameras: 'VaaS > Gerenciador de Câmeras > Status das Câmeras',
      },
      safr: {
        cameras: 'VaaS > SAFR > Câmeras',
        master_accounts: 'VaaS > SAFR > Contas Mestras',
        access_clearences: 'VaaS > SAFR > Acessos e Liberações',
      },
      ee_vms: {
        master_accounts: 'VaaS > EE VMS > Contas Mestras',
        accounts: 'VaaS > EE VMS > Contas',
        bridges: 'VaaS > EE VMS > Pontes',
        cameras: 'VaaS > EE VMS > Câmeras',
        presets: 'VaaS > EE VMS > Presets',
      },
      luxriot: {
        master_accounts: 'VaaS > Luxriot > Contas Mestras',
        cameras: 'VaaS > Luxriot > Câmeras',
      },
      omnicloud: {
        master_accounts: 'VaaS > OmniCloud > Contas Mestras',
        cameras: 'VaaS > OmniCloud > Câmeras',
        omnia_reseller: 'VaaS > OmniCloud > Revendedor da Omnia',
      },
      dahua: {
        dahua_dvr: 'VaaS > Dahua > Dahua DVR',
        dahua_cameras: 'VaaS > Dahua > Câmeras Dahua',
      },
      hanwha: {
        hanwha_dvr: 'VaaS > Hanwha > Hanwha DVR',
        hanwha_cameras: 'VaaS > Hanwha > Câmeras Hanwha',
      },
      hikvision: {
        master_accounts: 'VaaS > Hikvision > Contas Mestras',
        hikvision_dvr: 'VaaS > Hikvision > Hikvision DVR',
        hikvision_cameras: 'VaaS > Hikvision > Câmeras Hikvision',
      },
      generic_devices: 'VaaS > Dispositivos Genéricos',
      proxy_rtsp_server: 'VaaS > Servidores Proxy RTSP',
      recording_requests: {
        tag: 'VaaS > Solicitações de Gravação > Tag',
        recording_requests: 'VaaS > Solicitações de Gravação > Solicitações de Gravação',
      },
      analytics: {
        facial_recognition: {
          sarf: {
            events: 'VaaS > Análises > Reconhecimento Facial > SAFR > Eventos',
            groups: 'VaaS > Análises > Reconhecimento Facial > SAFR > Grupos',
            people: 'VaaS > Análises > Reconhecimento Facial > SAFR > Pessoas',
          },
          luna: {
            master_accounts: 'VaaS > Análises > Reconhecimento Facial > Luna > Contas Mestras',
            list: 'VaaS > Análises > Reconhecimento Facial > Luna > Lista',
            face: 'VaaS > Análises > Reconhecimento Facial > Luna > Rosto',
            facial_recognition_matches: 'VaaS > Análises > Reconhecimento Facial > Luna > Correspondências de Reconhecimento Facial',
            facestream: 'VaaS > Análises > Reconhecimento Facial > Luna > Transmissão facial',
          }
        },
        lpr: {
          plate_list: 'VaaS > Análises > LPR > Lista de Placas',
          plate: 'VaaS > Análises > LPR > Placa',
          lpr_matches: 'VaaS > Análises > LPR > Correspondências de LPR',
        },
        detections_events: 'VaaS > Análises > Eventos de Detecção',
      },
      video_watermarks: 'VaaS > Marcas d\'água em Vídeo',
      pacom: {
        master_accounts: 'IoT > Pacom > Contas Principais',
        sites: 'IoT > Pacom > Sites',
        actions: 'IoT > Pacom > Ações',
        schema_types: 'IoT > Pacom > Tipos de Esquema',
        entries: 'IoT > Pacom > Entradas',
        alarms: 'IoT > Pacom > Alarmes',
        alarmTypes: 'IoT > Pacom > Tipos de alarme',
        logs: 'IoT > Pacom > Logs'
      }
    },
    tenants: {
      all_tenants: 'Tenants > Todos os Tenants',
      master_tenants: 'Tenants > Tenants Mestres',
      incident_list: 'Tenants > Lista de Incidentes',
      incident_chart: 'Tenants > Gráfico de Incidentes',
      logs_incidents: 'Tenants > Registros de Incidentes',
      layouts: 'Tenants > Layouts',
      device_tag: 'Tenants > Tag do Dispositivo',
      token: 'Tenants > Token',
      token_omnitag: 'Tenants > Token Omnitag',
      tenants_storage: 'Tenants > Tenants Armazenar',
      tenants_storage_files: 'Tenants > Tenants Armazenar > Tenant Arquivos',
    },
    users: {
      all_users: 'Usuários > Todos os Usuários',
      profiles: 'Usuários > Perfis',
      permissions: 'Usuários > Permissões',
      groups: 'Usuários > Grupos',
      users_app: 'Usuários > Usuários do Aplicativo',
    },
    alarms: {
      all: 'Alarmes > Todos',
      seproban: 'Alarmes > Seproban',
      alarms_levels: 'Alarmes > Níveis de Alarme',
      alarm_comment: 'Alarmes > Comentário de Alarme',
      alarm_views: 'Alarmes > Visualizações de Alarme',
      alarm_purge: 'Alarmes > Purge de Alarme',
    },
    facilities: {
      all_facilities: 'Instalações > Todas as Instalações',
      centers: 'Instalações > Centros',
      sectors: 'Instalações > Setores',
      municipalities: 'Instalações > Municípios',
    },
    logs: {
      system_logs: 'Registros > Registros do Sistema',
      traffic: 'Registros > Tráfego',
      command_logs: 'Registros > Registros de Comandos',
      action_plan_logs: 'Registros > Registros de Planos de Ação',
    },
    iot: {
      buttons: {
        all_buttons: 'IoT > Todos os Botões',
        button_types: 'IoT > Tipos de Botões',
      },
      intelbras: {
        master_accounts: 'IoT > Intelbras > Contas Mestras',
        sites: 'IoT > Intelbras > Sites',
        alarm_types: 'IoT > Intelbras > Tipos de Alarme',
        alarms: 'IoT > Intelbras > Alarmes',
        log: 'IoT > Intelbras > Registro',
        rules: 'IoT > Intelbras > Regras',
      },
      dmp: {
        master_accounts: 'IoT > Dmp > Contas Mestras',
        panels: 'IoT > Dmp > Paneles',
        alarm_types: 'IoT > Dmp > Tipos de Alarme',
        alarms: 'IoT > Dmp > Alarmes',
        log: 'IoT > Dmp > Registro',
        rules: 'IoT > Dmp > Regras',
        profiles: 'IoT > Dmp > Perfiles',
        servers: 'IoT > Dmp > Servidores'
      },
      bosch: {
        panels: 'IoT > Bosch > Painéis',
        log: 'IoT > Bosch > Registro',
        rules: 'IoT > Bosch > Regras',
        profiles: 'IoT > Bosch > Perfis',
      }
    },
    automation: {
      custom_command: 'Automatização > Comando Personalizado',
      workflow: 'Automatização > Fluxo de Trabalho',
      action_plan: 'Automatização > Plano de Ação',
      document_action_plan: 'Automatização > Documentos do Plano de Ação',
      schedule_task: 'Automatização > Tarefa Agendada',
      alarm_commands: 'Automatização > Comandos de Alarme',
      scripts: 'Automatização > Comandos',
    },
    voip: {
      iotcomms_master_accounts: 'VoIP > Contas Mestras de IoTComms',
      types_devices_interphones: 'VoIP > Tipos de Dispositivos Interfones',
      devices_interphones: 'VoIP > Dispositivos Interfones',
      calls: 'VoIP > Chamadas',
      omnicloud: {
        master_account: 'VoIP > Omnicloud > Contas Master',
        devices: 'VoIP > Omnicloud > Dispositivos',
        calls: 'VoIP > Omnicloud > Ligações',
      }
    },
    risk: {
      risk_templates: "Evaluación de Riesgo > Plantillas Formulario"
    },
    security_self_audit:{
      templates : "Auto Auditorías de Seguridad > Plantillas Formulario",
      audits: "Auto Auditorías de Seguridad > Auditorías"
    },
    maintenance: {
      crew: 'Manutenção > Equipe de Manutenção',
      companies: 'Manutenção > Empresas de Manutenção',
      templates: 'Manutenção > Modelos de Manutenção',
      forms: 'Manutenção > Formulários de Manutenção',
    },
  },
}
